import { render, staticRenderFns } from "./updateProgress.vue?vue&type=template&id=1505f564&scoped=true&"
import script from "./updateProgress.vue?vue&type=script&lang=js&"
export * from "./updateProgress.vue?vue&type=script&lang=js&"
import style0 from "./updateProgress.vue?vue&type=style&index=0&id=1505f564&lang=less&scoped=true&"
import style1 from "./updateProgress.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505f564",
  null
  
)

export default component.exports